<template>
    <form ref="form" v-on="formEvents" class="overflow-hidden text-left" method="post">
        <div class="card-body bg-white shadow-sm rounded-lg overflow-hidden">
            <div >
                <transition-group name="slide-in-left">
                    <div key="step-one" class="bg-white" v-if="step === 'step-one'">
                        <transition name="slide-in-top">
                            <div v-if="formVisibility" class="text-center">
                                <h5 class="font-weight-bold">Organisation Information</h5>
                                <p class="alert alert-info">
                                    <i class="fa fa-info-circle"></i> All details here will be visible on your
                                    invoice
                                </p>
                            </div>
                        </transition>

                        <div class="form-group ">
                            <label>Organisation Name</label>
                            <input type="text"
                                   v-model="form.corporate_name"
                                   @keyup="showForm"
                                   required
                                   :disabled="isCorporate"
                                   :class="[ 'form-control' , form.errors.get('corporate_name') ? 'is-invalid' : '' ]"
                                   placeholder="Corporate Name">
                            <div v-text="form.errors.get('corporate_name')" class="invalid-feedback"/>
                        </div>

                        <transition name="slide-in-top">
                            <div v-if="formVisibility">
                                <div class="form-group">
                                    <label>Your Name ( Representative )</label>
                                    <input type="text" v-model="form.name" value=""
                                           required
                                           :disabled="isCorporate"
                                           :class="[ 'form-control' , form.errors.get('name') ? 'is-invalid' : '' ]"
                                           placeholder="Name">
                                    <div v-text="form.errors.get('name')" class="invalid-feedback"/>
                                </div>

                                <div class="form-group">
                                    <label>Your Phone</label>
                                    <input type="text" v-model="form.corporate_phone" value=""
                                           :disabled="isCorporate"
                                           :class="[ 'form-control' , form.errors.get('corporate_phone') ? 'is-invalid' : '' ]"
                                           placeholder="Corporate Phone">
                                    <div v-text="form.errors.get('corporate_phone')" class="invalid-feedback"/>
                                </div>

                                <div class="form-group">
                                    <label>Your Email</label>
                                    <input type="text" v-model="form.corporate_email" value=""
                                           :disabled="isCorporate"
                                           :class="[ 'form-control' , form.errors.get('corporate_email') ? 'is-invalid' : '' ]"
                                           placeholder="Corporate Email">
                                    <div v-text="form.errors.get('corporate_email')" class="invalid-feedback"/>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div key="step-two" class="bg-white" v-else>

                        <!--BILL BUTTONS-->
                        <div v-if="showBill === ''" class="row text-center">
                            <div class="col-12 col-md-6">
                                <div :style="cursorChange" @click="toggleBill('zesa')"  class=" card border-0 card-body d-flex flex-column justify-content-center  align-items-center hover:bg-accent hover:text-white">
                                    <div class="p-3">
                                        <i class="fas fa-file-excel fa-2x mr-2"></i>
                                    </div>
                                    <div class="d-inline-block ">
                                        <h6 class="mb-0">Buy ZESA</h6>
                                        <small>For multiple meters from an excel file</small>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div :style="cursorChange"  @click="toggleBill('airtime')" class="card border-0 card-body d-flex flex-column justify-content-center align-items-center hover:bg-accent hover:text-white">
                                    <div class="p-3">
                                        <i class="fas fa-file-excel fa-2x mr-2"></i>
                                    </div>
                                    <div class="d-inline-block ">
                                        <h6 class="mb-0">Buy Airtime & Bundles</h6>
                                        <small>For multiple numbers from an excel file</small>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!--BILL BUTTONS-->

                        <!--PAYMENT METHODS-->
                        <transition name="slide-in-left">
                            <div v-if="showBill === 'zesa' || showBill === 'airtime'">
                                <h5 class="font-weight-bold">Payment Information</h5>

                                <div class="form-group">
                                    <label class="d-flex">
                                        Pay with
                                        <strong class="ml-auto"> [ {{ methods[form.payment] }} ]</strong>
                                    </label>
                                    <select required v-model="form.payment"
                                            :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                                        <option value="">Choose Payment Method</option>
                                        <option value="wallet">Magetsi Wallet ZWG</option>
                                        <option value="wallet-usd">Magetsi Wallet USD</option>
                                    </select>
                                    <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                                </div>

                                <p v-if="form.payment"
                                   class="font-weight-bolder rounded text-1 text-center p-1 bg-info text-white">
                                    NB: All amounts in the below files should be in {{ methods[form.payment] }}
                                </p>
                            </div>
                        </transition>
                        <!--PAYMENT METHODS-->

                        <!-- ZESA Upload Section -->
                        <transition name="slide-in-left">
                            <div v-if="showBill === 'zesa'">
                                <div class="pt-4 row">
                                    <!-- Upload Option Selection -->
                                    <div class="col-md-12 mb-3">
                                        <div class="col-md-12 text-start">
                                            <label class="font-weight-bold">ZESA - Select Input Method:</label>
                                        </div>

                                        <div v-if="!systems.corp_zesa" class="py-4 alert alert-danger">
                                            <strong>NOTE:</strong> This service is unavailable at the moment. Please try again later.
                                        </div>
                                        <div v-else class="row d-flex justify-content-center align-items-center">
                                            <div class="py-2 alert alert-danger">
                                                <strong>NOTE:</strong> The Zesa Limit per meter is USD 500 or the ZWG equivalent.
                                            </div>
                                            <!-- Upload ZESA File Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.zesa === 'file'}"
                                                @click="toggleUploadOption('zesa', 'file')"
                                            >
                                                <div class="d-flex align-items-center justify-content-between ms-3 w-100">
                                                    <div class="d-flex align-items-center">
                                                        <i class="text-muted fas fa-file-upload fa-2x mr-2"></i>
                                                        <div>
                                                            <h5 class="text-3 mb-0">Upload ZESA File</h5>
                                                            <small class="d-none d-sm-block">Upload a CSV file.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.zesa === 'file' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>

                                            </div>
                                            <div class="d-none d-sm-block align-items-center justify-content-center">
                                                <h4 class="text-muted">-OR-</h4>
                                            </div>
                                            <!-- Select Existing Batch Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.zesa === 'batch'}"
                                                @click="toggleUploadOption('zesa', 'batch')"
                                            >
                                                <div class="d-flex align-items-center w-100">
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <i class="text-muted fas fa-layer-group fa-2x mr-2"></i>
                                                        <div class="ms-2">
                                                            <h5 class="text-3 mb-0">Select Stored Batch</h5>
                                                            <small class="d-none d-sm-block">Choose stored account batch.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.zesa === 'batch' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- File Upload Section -->
                                    <div v-if="uploadOption.zesa === 'file'" class="col-md-12">
                                        <div class="form-group">
                                            <div class="col-md-12 text-start">
                                                <label class="d-flex">ZESA File <span class="ml-auto"><a target="_blank" href="/business/sample/zesa" class="ml-auto">Download Sample File</a> [.csv]</span></label>
                                            </div>
                                            <file-upload
                                                fileType="csv"
                                                v-model="form.zesa"
                                                documentType="zesa"
                                                :disabled="!systems.corp_econet_usd"
                                                class="px-3"
                                            />
                                            <div v-text="form.errors.get('smart')" class="invalid-feedback bg-danger rounded-bottom text-white text-center text-1 mt-n1"/>
                                        </div>
                                    </div>
                                    <div v-if="uploadOption.zesa === 'batch'" class="col-md-12">
                                        <div class="col-md-12">
                                            <BatchSelection
                                                v-model="form.zesa"
                                                :bill-currency="computedCurrency"
                                                account-type="ZESA"
                                                is-bundle="account"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <!--AIRTIME BUNDLES-->
                        <transition name="slide-in-left">
                            <div v-if="showBill === 'airtime'">
                                <!-- Econet ZWG Airtime -->
                                <div class="pt-4 row" v-if="methods[form.payment] === 'ZWG'">
                                    <div class="col-md-12 mb-3">
                                        <div class="col-md-12 text-start">
                                            <label class="font-weight-bold">Econet ZWG Airtime - Select Input Method:</label>
                                        </div>
                                        <div v-if="!systems.corp_econet_zig" class="py-4 alert alert-danger">
                                            <strong>NOTE:</strong> This service is unavailable at the moment. Please try again later.
                                        </div>
                                        <div v-else class="row d-flex justify-content-center align-items-center">
                                            <!-- Upload File Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecZwgAirtime === 'file'}"
                                                @click="toggleUploadOption('ecZwgAirtime', 'file')"
                                            >
                                                <div class="d-flex align-items-center flex-grow-1">
                                                    <i class="text-muted fas fa-file-upload fa-2x mr-2"></i>
                                                    <div>
                                                        <h5 class="text-3 mb-0">Upload File</h5>
                                                        <small class="d-none d-sm-block">Upload a CSV file.</small>
                                                    </div>
                                                </div>
                                                <i :class="['fas', 'select-icon', uploadOption.ecZwgAirtime === 'file' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>

                                            </div>

                                            <div class="d-none d-sm-block align-items-center justify-content-center">
                                                <h4 class="text-muted">-OR-</h4>
                                            </div>

                                            <!-- Select Existing Batch Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecZwgAirtime === 'batch'}"
                                                @click="toggleUploadOption('ecZwgAirtime', 'batch')"
                                            >
                                                <div class="d-flex align-items-center flex-grow-1">
                                                    <i class="text-muted fas fa-layer-group fa-2x mr-2"></i>
                                                    <div>
                                                        <h5 class="text-3 mb-0">Select Stored Batch</h5>
                                                        <small class="d-none d-sm-block">Choose stored account batch.</small>
                                                    </div>
                                                </div>
                                                <i :class="['fas', 'select-icon', uploadOption.ecZwgAirtime === 'batch' ? 'fa-check-circle' : 'fa-circle','ms-auto']"></i>

                                            </div>
                                        </div>
                                    </div>
                                    <!-- File Upload Section -->
                                    <div v-if="uploadOption.ecZwgAirtime === 'file'" class="col-md-12">
                                        <div class="form-group">
                                            <div class="col-md-12 text-start">
                                                <label class="d-flex">Econet ZWG Airtime File <span class="ml-auto"><a target="_blank"  href="/business/sample/airtime" class="ml-auto">Download Sample File</a> [.csv]</span></label>
                                            </div>
                                            <file-upload
                                                fileType="csv"
                                                v-model="form.airtime"
                                                documentType="airtime"
                                                :disabled="!systems.corp_econet_usd"
                                                class="px-3"
                                            />
                                            <div v-text="form.errors.get('airtime')" class="invalid-feedback bg-danger rounded-bottom text-white text-center text-1 mt-n1"/>
                                            <div v-if="!systems.corp_econet_zig" class="bg-danger rounded-bottom text-white text-center text-1 mt-n1">
                                                <strong>NOTE:</strong> {{ 'The Econet ZWG service is unavailable at the moment. Please try again later.' }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Batch Selection Section -->
                                    <div v-if="uploadOption.ecZwgAirtime === 'batch'" class="col-md-12">
                                        <div class="col-md-12">
                                            <BatchSelection
                                                v-model="form.airtime"
                                                :bill-currency="computedCurrency"
                                                account-type="ECONET"
                                                is-bundle="account"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <!-- Econet ZWG Bundles -->
                                <div class="pt-4 row" v-if="methods[form.payment] === 'ZWG'">
                                    <div class="col-md-12 mb-3">
                                        <div class="col-md-12 text-start">
                                            <label class="font-weight-bold">Econet ZWG Bundles - Select Input Method:</label>
                                        </div>
                                        <div v-if="!systems.corp_econet_zig" class="py-4 alert alert-danger">
                                            <strong>NOTE:</strong> This service is unavailable at the moment. Please try again later.
                                        </div>
                                        <div v-else class="row d-flex justify-content-center align-items-center">
                                            <!-- Upload File Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecZwgBundles === 'file'}"
                                                @click="toggleUploadOption('ecZwgBundles', 'file')"
                                            >
                                                <div class="d-flex align-items-center justify-content-between ms-3 w-100">
                                                    <div class="d-flex align-items-center ms-3">
                                                        <i class="text-muted fas fa-file-upload fa-2x mr-2"></i>
                                                        <div>
                                                            <h5 class="text-3 mb-0">Upload File</h5>
                                                            <small class="d-none d-sm-block">Upload an Excel file for bulk processing.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.ecZwgBundles === 'file' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>
                                            </div>

                                            <div class="d-none d-sm-block align-items-center justify-content-center">
                                                <h4 class="text-muted">-OR-</h4>
                                            </div>

                                            <!-- Select Existing Batch Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecZwgBundles === 'batch'}"
                                                @click="toggleUploadOption('ecZwgBundles', 'batch')"
                                            >
                                                <div class="d-flex align-items-center flex-grow-1">
                                                    <i class="text-muted fas fa-layer-group fa-2x mr-2"></i>
                                                    <div>
                                                        <h5 class="text-3 mb-0">Select Stored Batch</h5>
                                                        <small class="d-none d-sm-block">Choose stored account batch..</small>
                                                    </div>
                                                </div>
                                                <i :class="['fas', 'select-icon', uploadOption.ecZwgBundles === 'batch' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- File Upload Section -->
                                    <div v-if="uploadOption.ecZwgBundles === 'file'" class="col-md-12">
                                        <div class="form-group">
                                            <div class="col-md-12 text-start">
                                                <label class="d-flex">Econet ZWG Airtime File <span class="ml-auto"><a target="_blank" href="/business/sample/bundle/v2" class="ml-auto">Download Sample File</a> [.xlsx]</span></label>
                                            </div>
                                            <file-upload
                                                fileType="xlsx"
                                                v-model="form.bundle"
                                                documentType="airtime"
                                                :disabled="!systems.corp_econet_usd"
                                                class="px-3"
                                            />
                                            <div v-text="form.errors.get('bundle')" class="invalid-feedback bg-danger rounded-bottom text-white text-center text-1 mt-n1"/>
                                            <div v-if="!systems.corp_econet_zig" class="bg-danger rounded-bottom text-white text-center text-1 mt-n1">
                                                <strong>NOTE:</strong> {{ 'The Econet ZWG service is unavailable at the moment. Please try again later.' }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Batch Selection Section -->
                                    <div v-if="uploadOption.ecZwgBundles === 'batch'" class="col-md-12">
                                        <div class="col-md-12">
                                            <BatchSelection
                                                v-model="form.bundle"
                                                is-bundle="bundle"
                                                :bill-currency="computedCurrency"
                                                account-type="ECONET"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!-- Econet USD Airtime -->
                                <div class="pt-4 row" v-if="methods[form.payment] === 'USD'">
                                    <div class="col-md-12 mb-3">
                                        <div class="col-md-12 text-start">
                                            <label class="font-weight-bold">Econet USD Airtime - Select Input Method:</label>
                                        </div>
                                        <div v-if="!systems.corp_econet_usd" class="py-4 alert alert-danger">
                                            <strong>NOTE:</strong> This service is unavailable at the moment. Please try again later.
                                        </div>
                                        <div v-else class="row d-flex justify-content-center align-items-center">
                                            <!-- Upload File Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecUsdAirtime === 'file'}"
                                                @click="toggleUploadOption('ecUsdAirtime', 'file')"
                                            >
                                                <div class="d-flex align-items-center justify-content-between ms-3 w-100">
                                                    <div class="d-flex align-items-center">
                                                        <i class="text-muted fas fa-file-upload fa-2x mr-2"></i>
                                                        <div>
                                                            <h5 class="text-3 mb-0">Upload File</h5>
                                                            <small class="d-none d-sm-block">Upload a CSV file for bulk processing.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.ecUsdAirtime === 'file' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>
                                            </div>

                                            <div class="d-none d-sm-block align-items-center justify-content-center">
                                                <h4 class="text-muted">-OR-</h4>
                                            </div>

                                            <!-- Select Existing Batch Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecUsdAirtime === 'batch'}"
                                                @click="toggleUploadOption('ecUsdAirtime', 'batch')"
                                            >
                                                <div class="d-flex align-items-center w-100">
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <i class="text-muted fas fa-layer-group fa-2x mr-2"></i>
                                                        <div class="ms-2">
                                                            <h5 class="text-3 mb-0">Select Stored Batch</h5>
                                                            <small class="d-none d-sm-block">Choose stored account batch.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.ecUsdAirtime === 'batch' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- File Upload Section -->
                                    <div v-if="uploadOption.ecUsdAirtime === 'file'" class="col-md-12">
                                        <div class="form-group">
                                            <div class="col-md-12 text-start">
                                                <label class="d-flex">Econet USD Airtime File <span class="ml-auto"><a target="_blank"  href="/business/sample/airtime" class="ml-auto">Download Sample File</a> [.csv]</span></label>
                                            </div>
                                            <file-upload
                                                fileType="csv"
                                                v-model="form.airtime"
                                                documentType="airtime"
                                                :disabled="!systems.corp_econet_usd"
                                                class="px-3"
                                            />
                                            <div v-text="form.errors.get('airtime')" class="invalid-feedback bg-danger rounded-bottom text-white text-center text-1 mt-n1"/>
                                            <div v-if="!systems.corp_econet_usd" class="bg-danger rounded-bottom text-white text-center text-1 mt-n1">
                                                <strong>NOTE:</strong> {{ 'The Econet USD service is unavailable at the moment. Please try again later.' }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Batch Selection Section -->
                                    <div v-if="uploadOption.ecUsdAirtime === 'batch'" class="col-md-12">
                                        <div class="col-md-12">
                                            <BatchSelection
                                                v-model="form.airtime"
                                                :bill-currency="computedCurrency"
                                                account-type="ECONET"
                                                is-bundle="account"
                                            />

                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <!-- Econet Smart Bundles -->
                                <div class="pt-4 row" v-if="methods[form.payment] === 'USD'">
                                    <div class="col-md-12 mb-3">
                                        <div class="col-md-12 text-start">
                                            <label class="font-weight-bold">Econet Smart Bundles - Select Input Method:</label>
                                        </div>
                                        <div v-if="!systems.corp_econet_usd" class="py-4 alert alert-danger">
                                            <strong>NOTE:</strong> This service is unavailable at the moment. Please try again later.
                                        </div>
                                        <div v-else class="row d-flex justify-content-center align-items-center">
                                            <!-- Upload File Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecSmartBundles === 'file'}"
                                                @click="toggleUploadOption('ecSmartBundles', 'file')"
                                            >
                                                <div class="d-flex align-items-center justify-content-between ms-3 w-100">
                                                    <div class="d-flex align-items-center">
                                                        <i class="text-muted fas fa-file-upload fa-2x mr-2"></i>
                                                        <div>
                                                            <h5 class="text-3 mb-0">Upload File</h5>
                                                            <small class="d-none d-sm-block">Upload an Excel file for bulk processing.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.ecSmartBundles === 'file' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>

                                            </div>

                                            <div class="d-none d-sm-block align-items-center justify-content-center">
                                                <h4 class="text-muted">-OR-</h4>
                                            </div>

                                            <!-- Select Existing Batch Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.ecSmartBundles === 'batch'}"
                                                @click="toggleUploadOption('ecSmartBundles', 'batch')"
                                            >
                                                <div class="d-flex align-items-center w-100">
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <i class="text-muted fas fa-layer-group fa-2x mr-2"></i>
                                                        <div class="ms-2">
                                                            <h5 class="text-3 mb-0">Select Stored Batch</h5>
                                                            <small class="d-none d-sm-block">Choose stored account batch..</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.ecSmartBundles === 'batch' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- File Upload Section -->
                                    <div v-if="uploadOption.ecSmartBundles === 'file'" class="col-md-12">
                                        <div class="form-group">
                                            <div class="col-md-12 text-start">
                                                <label class="d-flex">Econet Smart Bundles File <span class="ml-auto"><a target="_blank" href="/business/sample/smart/v2" class="ml-auto">Download Sample File</a> [.xlsx]</span></label>
                                            </div>
                                            <file-upload
                                                fileType="xlsx"
                                                v-model="form.smart"
                                                documentType="airtime"
                                                :disabled="!systems.corp_econet_usd"
                                                class="px-3"
                                            />
                                            <div v-text="form.errors.get('smart')" class="invalid-feedback bg-danger rounded-bottom text-white text-center text-1 mt-n1"/>
                                            <div v-if="!systems.corp_econet_usd" class="bg-danger rounded-bottom text-white text-center text-1 mt-n1">
                                                <strong>NOTE:</strong> {{ 'The Econet USD service is unavailable at the moment. Please try again later.' }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Batch Selection Section -->
                                    <div v-if="uploadOption.ecSmartBundles === 'batch'" class="col-md-12">
                                        <div class="col-md-12">
                                            <BatchSelection
                                                v-model="form.smart"
                                                is-bundle="bundle"
                                                :bill-currency="computedCurrency"
                                                account-type="ECONET"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <!-- Netone Bundles -->
                                <div class="pt-4 row" v-if="methods[form.payment] === 'USD'">
                                    <div class="col-md-12 mb-3">
                                        <div class="col-md-12 text-start">
                                            <label class="font-weight-bold">NetOne USD Bundles - Select Input Method:</label>
                                        </div>
                                        <div v-if="!systems.corp_netone_usd" class="py-4 alert alert-danger">
                                            <strong>NOTE:</strong> This service is unavailable at the moment. Please try again later.
                                        </div>
                                        <div v-else class="row d-flex justify-content-center align-items-center">
                                            <!-- Upload File Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.netoneUsdBundles === 'file'}"
                                                @click="toggleUploadOption('netoneUsdBundles', 'file')"
                                            >
                                                <div class="d-flex align-items-center justify-content-between ms-3 w-100">
                                                    <div class="d-flex align-items-center">
                                                        <i class="text-muted fas fa-file-upload fa-2x mr-2"></i>
                                                        <div>
                                                            <h5 class="text-3 mb-0">Upload File</h5>
                                                            <small class="d-none d-sm-block">Upload an Excel file for bulk processing.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.netoneUsdBundles === 'file' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>

                                            </div>

                                            <div class="d-none d-sm-block align-items-center justify-content-center">
                                                <h4 class="text-muted">-OR-</h4>
                                            </div>

                                            <!-- Select Existing Batch Option -->
                                            <div
                                                class="col-lg-5 col-5 payout-card d-flex align-items-center text-center position-relative"
                                                :class="{'selected': uploadOption.netoneUsdBundles === 'batch'}"
                                                @click="toggleUploadOption('netoneUsdBundles', 'batch')"
                                            >
                                                <div class="d-flex align-items-center justify-content-between ms-3 w-100">
                                                    <div class="d-flex align-items-center">
                                                        <i class="text-muted fas fa-layer-group fa-2x mr-2"></i>
                                                        <div>
                                                            <h5 class="text-3 mb-0">Select Stored Batch</h5>
                                                            <small class="d-none d-sm-block">Choose stored account batch.</small>
                                                        </div>
                                                    </div>
                                                    <i :class="['fas', 'select-icon', uploadOption.netoneUsdBundles === 'batch' ? 'fa-check-circle' : 'fa-circle', 'ms-auto']"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- File Upload Section -->
                                    <div v-if="uploadOption.netoneUsdBundles === 'file'" class="col-md-12">
                                        <div class="form-group">

                                            <div class="col-md-12 text-start">
                                                <label class="d-flex">NetOne USD Bundles File <span class="ml-auto"><a target="_blank" href="/business/sample/netone" class="ml-auto">Download Sample File</a> [.xlsx]</span></label>
                                            </div>
                                            <file-upload
                                                fileType="xlsx"
                                                v-model="form.netone"
                                                documentType="airtime"
                                                :disabled="!systems.corp_econet_usd"
                                                class="px-3"
                                            />
                                            <div v-text="form.errors.get('netone')" class="invalid-feedback bg-danger rounded-bottom text-white text-center text-1 mt-n1"/>
                                            <div v-if="!systems.corp_netone_usd" class="bg-danger rounded-bottom text-white text-center text-1 mt-n1">
                                                <strong>NOTE:</strong> {{ 'The NetOne service is unavailable at the moment. Please try again later.' }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Batch Selection Section -->
                                    <div v-if="uploadOption.netoneUsdBundles === 'batch'" class="col-md-12">
                                        <div class="col-md-12">
                                            <BatchSelection
                                                v-model="form.netone"
                                                is-bundle="bundle"
                                                :bill-currency="computedCurrency"
                                                account-type="NETONE"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <!--AIRTIME BUNDLES-->
                        <!--BILL BACK BUTTONS-->
                        <div v-if="showBill === 'zesa' || showBill === 'airtime'" class="row text-center">
                            <div v-if="showBill === 'airtime'" class="col-12 p-1">
                                <div :style="cursorChange" @click="toggleBill('zesa')"  class=" p-1 card border-0 card-body d-flex flex-row justify-content-center  align-items-center hover:bg-accent hover:text-white">
                                    <div class="p-1">
                                        <i class="fas fa-arrow-left fa-1x mr-2"></i>
                                    </div>
                                    <div class="d-inline-block ">
                                        <h6 class="mb-0">Buy ZESA Instead?</h6>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showBill === 'zesa'" class="col-12">
                                <div :style="cursorChange"  @click="toggleBill('airtime')" class=" p-1 card border-0 card-body d-flex flex-row justify-content-center align-items-center hover:bg-accent hover:text-white">
                                    <div class="p-1">
                                        <i class="fas fa-arrow-left fa-1x mr-2"></i>
                                    </div>
                                    <div class="d-inline-block ">
                                        <h6 class="mb-0">Buy Airtime & Bundles Instead?</h6>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!--BILL BACK BUTTONS-->

                    </div>
                </transition-group>
            </div>
        </div>
        <transition name="slide-in-left">
            <div  v-if="showBill === 'zesa' || showBill === 'airtime'" class="card-footer bg-white text-center">
                <button
                    v-if="step === 'step-one'"
                    v-bind="buttonValidity"
                    :class="{'btn-loading': form.loading, ...buttonValidity.class }"
                    @click.prevent="next">
                    Next
                </button>

                <div class="row" v-else>
                    <div class="col-md-6" v-if="!user.corporate">
                        <button class="btn btn-block btn-outline-primary mb-2 mb-md-0" @click.prevent="step = 'step-one'">
                            Previous
                        </button>
                    </div>
                    <div :class="[user.corporate ? 'col-md-12' : 'col-md-6']">
                        <button v-if="step === 'step-two'"
                                @click.prevent="submit()"
                                v-bind="buttonValidity"
                                :class="{'btn-loading': form.loading, ...buttonValidity.class }">
                            Submit
                        </button>
                    </div>
                </div>

                <router-link to="/business/transact" class="btn btn-link shadow-none mt-2">
                    Start Again?
                </router-link>
            </div>
        </transition>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import { storage } from "../../../core/utils/storage";
import { validity } from "../../../core/forms/validity";
import { systems } from "../../../core/data/global";
import FileUpload from '../../../components/corporate/components/FileUpload.vue';
import BatchSelection from "../../corporate/components/BatchSelection.vue";

export default {
    name: "BusinessInitExcel",
    components: {
        BatchSelection,
        PhoneInput: () => import("../../custom/phone-input.vue"),
        FileUpload
    },
    mixins: [storage, validity, systems],

    mounted() {
        this.initStorage([
            'corporate_name',
            'corporate_phone',
            'corporate_email',
            'email',
            'ecocash',
            'payment',
            'name',
        ]);
        this.form.payment = 'wallet-usd';
        this.init();

        if (this.user.corporate) this.step = 'step-two';
    },

    methods: {
        toggleBill(billName) {
            if (billName === "airtime") {
                this.form.zesa = null;
                this.uploadOption.zesa = "";
            }

            if (billName === "zesa") {
                this.form.airtime = null;
                this.form.bundle = null;
                this.form.smart = null;
                this.form.netone = null;
            }
            this.showBill = this.showBill === billName ? "" : billName;
        },

        toggleUploadOption(bundleType, option) {
            const optionToFormMapping = {
                zesa: "zesa",
                ecZwgAirtime: "airtime",
                ecUsdAirtime: "airtime",
                ecZwgBundles: "bundle",
                ecSmartBundles: "smart",
                netoneUsdBundles: "netone"
            };

            const formField = optionToFormMapping[bundleType];

            if (this.uploadOption[bundleType] === option) {
                this.$set(this.uploadOption, bundleType, '');
                this.$set(this.form, formField, null);
            } else {
                // Switch to new option
                this.$set(this.uploadOption, bundleType, option);
            }

        },

        checkCorporate() {
            this.isCorporate = this.user.corporate_id !== undefined;
            if (this.isCorporate) {
                window.axios.get(`/business/settings/api`).then((response) => {
                    this.form.corporate_name = response.data.body.model.name;
                    this.form.name = response.data.body.model.contact_name;
                    this.form.corporate_phone = response.data.body.model.contact_phone;
                    this.form.corporate_email = response.data.body.model.contact_email;
                    this.form.name = response.data.body.model.contact_name;
                });
            }
        },

        init() {
            this.loading = true;
            window.axios.get(`${window.location.origin}/business/init`).then((response) => {
                this.clear = response.data.body.clear;
                this.checkCorporate();
            }).finally(() => {
                this.loading = false;
            });
        },

        next() {
            if (this.formVisibility) this.step = 'step-two';
            else this.formVisibility = true;
        },
        isFormValid() {
            return (
                this.form.zesa ||
                this.form.netone ||
                this.form.airtime ||
                this.form.bundle ||
                this.form.smart
            );
        },

        submit: async function () {
            this.saveToLocalStorage();

            if (!this.isFormValid()) {
                this.$toast.error("Please ensure all required fields are filled correctly.", { timeout: 3000 });
                return;
            }

            try {
                const response = await this.form.upload('/business/submit');

                if (response.data.success) {
                    this.batch = response.data.body.batch;
                    await this.$router.push(`/business/view?ref=${this.batch.ref}`);
                } else {
                    this.$toast.error(response.data.message || "An error occurred. Please try again.", { timeout: 3000 });
                }
            } catch (error) {
                this.$toast.error("Failed to submit. Check displayed errors and try again.", { timeout: 3000 });
            }
        }


    },

    data() {
        return {
            user: window.user,
            isCorporate: false,
            clear: false,
            step: 'step-one',
            termsAccepted: 'true',

            uploadOption: {
                zesa: '',
                ecZwgAirtime: '',
                ecZwgBundles: '',
                ecUsdAirtime: '',
                ecSmartBundles: '',
                netoneUsdBundles: '',
            },
            methods: {
                'ecocash': 'ZWG',
                'ecocash-usd': 'USD',
                'bank-usd': 'USD',
                'stripe': 'USD',
                'wallet': 'ZWG',
                'wallet-usd': 'USD',
            },
            cursorChange: {
                cursor: "pointer"
            },
            showBill: '',
            form: new Form({
                name: "",
                corporate_name: "",
                corporate_phone: "",
                corporate_email: "",
                payment: "",
                zesa: null,
                netone: null,
                airtime: null,
                bundle: null,
                smart: null,
                email: ""
            })
        };
    },
    watch: {
        "form.payment"(newValue) {
            this.$nextTick(() => {
                this.form.currency = newValue === "wallet" ? "ZWG" : "USD";
                this.form.airtime = null;
                this.form.bundle = null;
                this.form.smart = null;
                this.form.netone = null;
            });
        },
        "form.zesa"(newValue) {
            if (newValue) this.checkValidity();
        },
        "form.airtime"(newValue) {
            if (newValue) this.checkValidity();
        },
        "form.bundle"(newValue) {
            if (newValue) this.checkValidity();
        }
    },
    computed: {
        systems() {
            return systems;
        },
        computedCurrency() {
            return this.form.payment === "wallet" ? "ZWG" : "USD";
        }
    }
}

</script>
<style scoped>
    .payout-card {
        padding: 20px;
        border: 2px solid #ddd;
        border-radius: 8px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        margin: 10px;
        position: relative;
        gap: 12px;
    }
    .payout-card h5,
    .payout-card small {
        text-align: left;
    }
    .payout-card:hover {
        border-color: #252c65;
    }
    .selected {
        border-color: #28a745 !important;
        background-color: #e9f5e9;
    }
    .select-icon {
        font-size: 1.5rem;
        color: #ddd;
    }
    .selected .select-icon {
        color: #28a745;
    }
</style>
